// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAslwdBXTxRF1qD3qzVlUgp5KTM7Y-yIt0",
  authDomain: "programs-portal-final.firebaseapp.com",
  projectId: "programs-portal-final",
  storageBucket: "programs-portal-final.firebasestorage.app",
  messagingSenderId: "876233846698",
  appId: "1:876233846698:web:1663565bf373a8607805d3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

// ✅ NEW: Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Configure Google Auth Provider
googleProvider.setCustomParameters({
  prompt: 'select_account', // Always show account selection
  hd: undefined // Remove domain restriction if any
});

// Add additional scopes if needed (optional)
googleProvider.addScope('profile');
googleProvider.addScope('email');

// ✅ Development environment check (optional)
// Uncomment these if you want to use Firebase Emulators for development
/*
if (process.env.NODE_ENV === 'development') {
  // Connect to emulators if in development
  if (!auth._settings?.appVerificationDisabledForTesting) {
    connectAuthEmulator(auth, "http://localhost:9099");
  }
  
  if (!db._settings) {
    connectFirestoreEmulator(db, 'localhost', 8080);
  }
  
  if (!storage._location) {
    connectStorageEmulator(storage, "localhost", 9199);
  }
}
*/

// ✅ Auth state persistence (optional enhancement)
// This ensures the user stays logged in across browser sessions
auth.useDeviceLanguage(); // Use device language for auth UI

// ✅ Export a helper function to check if user is admin
export const checkUserRole = async (uid) => {
  try {
    const { doc, getDoc } = await import("firebase/firestore");
    const userDoc = await getDoc(doc(db, "users", uid));
    return userDoc.exists() ? userDoc.data().role : "user";
  } catch (error) {
    console.error("Error checking user role:", error);
    return "user"; // Default to user role on error
  }
};

// ✅ Export helper function for creating user profile
export const createUserProfile = async (uid, userData) => {
  try {
    const { doc, setDoc, serverTimestamp } = await import("firebase/firestore");
    await setDoc(doc(db, "users", uid), {
      ...userData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      role: userData.role || "user"
    });
    return true;
  } catch (error) {
    console.error("Error creating user profile:", error);
    return false;
  }
};

// ✅ Export helper function for updating user profile
export const updateUserProfile = async (uid, updates) => {
  try {
    const { doc, updateDoc, serverTimestamp } = await import("firebase/firestore");
    await updateDoc(doc(db, "users", uid), {
      ...updates,
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error("Error updating user profile:", error);
    return false;
  }
};

// ✅ Export auth state observer helper
export const onAuthStateChange = (callback) => {
  const { onAuthStateChanged } = require("firebase/auth");
  return onAuthStateChanged(auth, callback);
};

export default app;